__turbopack_context__.v({
  "vimeoContainer": "VimeoEmbed-module-scss-module__9PDWpa__vimeoContainer",
});
